import { createFileRoute } from '@tanstack/react-router';
import { sponsoredQuery } from '@/features/sponsored/api';
import { SponsoredPage } from '@/features/sponsored/pages/SponsoredPage';

export const Route = createFileRoute('/_authed/ops/sponsored/')({
  staticData: { help: 'sponsored' },
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(sponsoredQuery());
  },
  component: SponsoredPage,
});
